import { Address } from './address';
import { AsylumResult } from './asylum-result';
import { BankingDetails } from './banking-details';
import { BaseModel } from './base.model';
import { BiometricResult } from './biometric-result';
import { Document } from './document';
import { Profile } from './profile';
import { Signature } from './signature';
import { UserCriminalRecordCheck } from './user-criminal-record-check';
import { Vehicle } from './vehicle';

export enum Role {
  ADMIN = 'admin',
  USER = 'user',
  SERVICE_PROVIDER_ADMIN = 'service-provider-admin',
}

export class User extends BaseModel {
  email?: string = '';
  role: string = '';
  mobile: string = '';
  profile?: Profile;
  address?: Address;
  documents?: Document[];
  vehicle?: Vehicle;
  carTrackDriverId?: string;
  biometricResult?: BiometricResult;
  asylumResult?: AsylumResult;
  contractSignature?: Signature;
  bankingDetails?: BankingDetails;
  criminalRecordCheck?: UserCriminalRecordCheck;

  constructor(data: Partial<User>) {
    super();
    Object.assign(this, data);
  }
}
